document.addEventListener('DOMContentLoaded', () => {
  const downloadWrappers = document.querySelectorAll(
    '.recipebook__download-wrapper'
  )

  downloadWrappers.forEach((wrapper) => {
    const button = wrapper.querySelector('.recipebook__info-download')
    const dropdownMenu = wrapper.querySelector('.recipebook__dropdown-menu')

    if (!button || !dropdownMenu) return

    button.addEventListener('click', (event) => {
      event.stopPropagation()
      toggleDropdown(button, dropdownMenu)
    })
  })

  document.addEventListener('click', () => {
    closeAllDropdowns()
  })

  // Escape 키로 드롭다운 닫기
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const openDropdown = document.querySelector(
        '.recipebook__dropdown-menu.s-active'
      )
      if (openDropdown) {
        const controllingButton = document.querySelector(
          `[aria-controls="${openDropdown.id}"][aria-expanded="true"]`
        )
        closeDropdown(controllingButton, openDropdown)
        controllingButton?.focus() // 닫은 후 버튼으로 초점 이동
      }
    }
  })

  function toggleDropdown(button, dropdownMenu) {
    const isExpanded = button.getAttribute('aria-expanded') === 'true'
    closeAllDropdowns() // 다른 모든 드롭다운 닫기
    if (!isExpanded) {
      openDropdown(button, dropdownMenu)
    }
  }

  function openDropdown(button, dropdownMenu) {
    dropdownMenu.classList.add('s-active')
    button.setAttribute('aria-expanded', 'true')
    // 드롭다운이 열리면 첫 번째 항목으로 초점 이동
    dropdownMenu.querySelector('[role="menuitem"]')?.focus()
  }

  function closeDropdown(button, dropdownMenu) {
    if (!dropdownMenu.classList.contains('s-active')) return
    dropdownMenu.classList.remove('s-active')
    button?.setAttribute('aria-expanded', 'false')
  }

  function closeAllDropdowns() {
    document
      .querySelectorAll('.recipebook__dropdown-menu.s-active')
      .forEach((dropdown) => {
        const button = document.querySelector(
          `[aria-controls="${dropdown.id}"]`
        )
        closeDropdown(button, dropdown)
      })
  }
})
